import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import DesignYourSmartOffice from "./sections/DesignYourSmartOffice";
import OurLocation from "./sections/OurLocation";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <DesignYourSmartOffice />
      <OurLocation />
      <Footer />
    </div>;
}